const routes = [
  // 首页
  {
    path: "/home",
    name: "Home",
    meta: { title: "首页" },
    component: () =>
      import(/* webpackChunkName: "home" */ "@/views/portal/home")
  },
  // 产品页
  {
    path: "/products",
    name: "Products",
    meta: { title: "产品页" },
    component: () =>
      import(/* webpackChunkName: "products" */ "@/views/portal/products"),
    props: route => ({
      // 产品页面名称
      pageName: route.query.page,
      // 组合单品页面是否自动滚动到对应的产品模块
      // 当 query.nav 为 0 | false | null 时，页面不自动滚动
      isAutoScrollNav: !["0", "false", "null"].includes(
        String(route.query.nav).toLowerCase()
      )
    })
  },
  // 车型生命周期管理
  {
    path: "/car-life-cycle",
    name: "CarLifeCycle",
    meta: { title: "车型生命周期管理" },
    component: () =>
      import(
        /* webpackChunkName: "car-life-cycle" */ "@/views/portal/car-life-cycle"
      )
  },
  // 用户生命周期管理
  {
    path: "/user-life-cycle",
    name: "UserLifeCycle",
    meta: { title: "用户生命周期管理" },
    component: () =>
      import(
        /* webpackChunkName: "user-life-cycle" */ "@/views/portal/user-life-cycle"
      )
  },
  // 运营管理智能决策系统
  {
    path: "/intelligent-decision",
    name: "IntelligentDecision",
    meta: { title: "运营管理智能决策系统" },
    component: () =>
      import(
        /* webpackChunkName: "intelligent-decision" */ "@/views/portal/intelligent-decision"
      )
  },
  // 行业洞察
  {
    path: "/industry-insights",
    name: "IndustryInsights",
    meta: { title: "行业洞察" },
    component: () =>
      import(
        /* webpackChunkName: "industry-insights" */ "@/views/portal/insights"
      )
  },
];

export default routes;
